<template>
  <v-card id="calendar" dense class="overflow-hidden" width="60px" elevation="6">
    <v-card-text class="d-flex flex-column pa-0">
      <div class="red white--text px-2 text-uppercase text-center" style="font-size: 12px;">{{ $moment().format('MMM') }}</div>
      <div class="d-flex text-h5 align-center justify-center black--text" style="height:38px;">
        {{ $moment().format('D') }}
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
export default {
  components: {
    //
  },
  computed: mapState({
    //
  }),
  props: [
    //
  ],
  data: () => ({
    //
  }),
  created() {
    //
  },
  mounted() {
    //
  },
  methods: {
    //
  }
}
</script>